import { StreamWebRTC } from "../webrtc/stream_webrtc";
import { STREAM_TYPE_LIVE, STREAM_TYPE_PLAYBACK } from "../common/base";
import { ControllerBase } from "./webrtc_controller";
export class StreamController extends ControllerBase {
    constructor(options, settings) {
        super(options, StreamWebRTC);
        this.streamType = settings.streamType;
        this.streamParams = settings.streamParams;
        this.video = settings.video;
        this.audio = settings.audio;
        this.canvas = settings.canvas;
        //
        this.webRTC.addEventListener(StreamWebRTC.EVENT_TIME_UPDATE, (currentTime) => {
            let progress = 0;
            if (settings.streamType === STREAM_TYPE_PLAYBACK) {
                let streamParams = this.streamParams;
                let diff = streamParams.endAt - streamParams.startAt;
                if (diff !== 0) {
                    progress = currentTime / diff;
                    if (progress < 0)
                        progress = 0;
                    else if (progress > 1)
                        progress = 1;
                }
            }
            this.emitEvent(StreamController.EVENT_TIME_PROGRESS, currentTime, progress);
        });
    }
    sendOffer(offer, traceHeader) {
        let offerObj = {
            orgId: this.orgId, connectId: this.connectId, turn: this.turn,
            rtcToken: this.rtcToken, offer: offer.sdp,
            traceHeader
        };
        if (this.streamType === STREAM_TYPE_LIVE) {
            this.signal.sendLiveOffer(this, offerObj, this.streamParams, this.webRTC.getSelectedVideoCodec());
        }
        else if (this.streamType === STREAM_TYPE_PLAYBACK) {
            this.signal.sendPlaybackOffer(this, offerObj, this.streamParams, this.webRTC.getSelectedVideoCodec());
        }
    }
    async doOnAnswer(reply) {
        let resolution = reply.streamResult.streamInfo.VideoEncodeInfo.Resolution;
        this.emitEvent(StreamController.EVENT_MODE, reply.mode);
        await this.webRTC.onAnswer({
            modeCode: reply.mode,
            fps: reply.streamResult.streamInfo.VideoEncodeInfo.FrameRate,
            resolution: { width: resolution.Width, height: resolution.Height },
            video: this.video,
            audio: this.audio,
            canvas: this.canvas,
            tunnelParams: reply.streamResult.tunnelParams
        }, reply.answer);
    }
    doGetDesc() {
        return { connectId: this.connectId, nvrId: this.nvrId, streamParams: this.streamParams };
    }
    pause(callback) {
        this.webRTC.pause(callback);
    }
    resume(callback) {
        this.webRTC.resume(callback);
    }
    seek(seek, callback) {
        this.webRTC.seek(seek, callback);
    }
    scale(scale, callback) {
        this.webRTC.scale(scale, callback);
    }
    speed(speed, callback) {
        this.webRTC.speed(speed, callback);
    }
    ptz(param, callback) {
        this.webRTC.ptz(param, callback);
    }
}
StreamController.EVENT_MODE = 'mode';
StreamController.EVENT_TIME_PROGRESS = 'time_progress';
